<template>
    <section class="timetable-group">
        <div class="date">
            <button class="btn-reset date__btn btn-previous" @click="paginationStep(-1)" v-bind:class="{firstWeek}">
                <svg width="61" height="72" viewBox="0 0 61 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40 5.5L36 1L1 37L36 71L40 67L10 37L40 5.5Z" fill="#A3BFEF" stroke="#A3BFEF"/>
                    <path d="M60 5.5L56 1L21 37L56 71L60 67L30 37L60 5.5Z" fill="#A3BFEF" stroke="#A3BFEF"/>
                </svg>                    
            </button>
            <div class="date__container">
                <div class="date__title-container">
                    <h2 class="date__title">{{$route.params.group ?? $route.params.teacher}}</h2>
                    <!--<a :href=documentDownload class="date__document" target="_blank" rel="noopener noreferrer">
                        <svg width="36" height="50" viewBox="0 0 48 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M46.7741 13.2761L46.7742 13.2762C47.2416 13.7363 47.5 14.3587 47.5 14.9994V15.25H32.5V0.5H32.7625C33.4341 0.5 34.0697 0.758009 34.5366 1.21748C34.5366 1.21754 34.5367 1.21759 34.5367 1.21765L46.7741 13.2761ZM3 0.5H27.5V16.7344C27.5 18.6421 29.0813 20.1875 31 20.1875H47.5V60.0469C47.5 61.3999 46.3938 62.5 45 62.5H3C1.60619 62.5 0.5 61.3999 0.5 60.0469V2.95312C0.5 1.60014 1.60619 0.5 3 0.5ZM34.5 47.75C35.5937 47.75 36.5 46.8691 36.5 45.7734V44.7891C36.5 43.6934 35.5937 42.8125 34.5 42.8125H13.5C12.4063 42.8125 11.5 43.6934 11.5 44.7891V45.7734C11.5 46.8691 12.4063 47.75 13.5 47.75H34.5ZM34.5 39.875C35.5937 39.875 36.5 38.9941 36.5 37.8984V36.9141C36.5 35.8184 35.5937 34.9375 34.5 34.9375H13.5C12.4063 34.9375 11.5 35.8184 11.5 36.9141V37.8984C11.5 38.9941 12.4063 39.875 13.5 39.875H34.5ZM36.5 30.0234V29.0391C36.5 27.9434 35.5937 27.0625 34.5 27.0625H13.5C12.4063 27.0625 11.5 27.9434 11.5 29.0391V30.0234C11.5 31.1191 12.4063 32 13.5 32H34.5C35.5937 32 36.5 31.1191 36.5 30.0234Z" fill="#CAE5FF" stroke="#A3BFEF"/>
                        </svg>
                    </a>-->
                </div>
                <div class="date__description">
                    <p class="date__description-time">{{String(weekDates.firstday.toLocaleDateString()) + " — " + String(weekDates.lastday.toLocaleDateString()) + isSeason}}</p>
                    <p class="date__description-week">(неделя по {{isUpWeek? 'знаменателю':'числителю'}}) </p>
                </div>
                
            </div>
            <button class="btn-reset date__btn btn-next"  @click="paginationStep(1)" v-bind:class="{lastWeek}">
                <svg width="61" height="72" viewBox="0 0 61 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 66.5L25 71L60 35L25 0.999997L21 5L51 35L21 66.5Z" fill="#A3BFEF" stroke="#A3BFEF"/>
                    <path d="M1 66.5L5 71L40 35L5.00001 0.999997L1.00001 5L31 35L1 66.5Z" fill="#A3BFEF" stroke="#A3BFEF"/>
                </svg>
            </button>
        </div>
        
        <div class="timetable-group__container timetable container">
            <div class="timetable__list-container row">
                <div class="col-2"></div>
                <div class="container col-10">
                    <ul class="timetable__list-names timetable-names row">
                        <li class="timetable-names__item timetable-name col-1"><p class="timetable-name__description">Время</p></li>
                        <li class="timetable-names__item timetable-name col-6"><p class="timetable-name__description">Название дисциплины</p></li>
                        <li class="timetable-names__item timetable-name col-2"><p class="timetable-name__description">Вид</p></li>
                        <!--<li class="timetable-names__item timetable-name col-2"><p class="timetable-name__description">Преподаватель</p></li>-->
                        <li class="timetable-names__item timetable-name col-2"><p class="timetable-name__description">Аудитория</p></li>
                        <li class="timetable-names__item timetable-name col-1"><p class="timetable-name__description">Адрес</p></li>
                    </ul>
                </div>
            </div>
            <ul class="timetable__list-weekdays weekdays__list">
                <li class="weekdays__item day row" v-for="(items, day) in timetable" :key="day">
                    <div class="day__container col-5 col-xs-4 col-md-4 col-lg-2">
                        <h3 class="day__title">{{day}}</h3>
                        <p class="day__description" >{{weekDates.daysNames[dayName.indexOf(day)]}}</p>
                    </div>
                    <ul class="day__list col-12 col-xs-12 col-md-12 col-lg-10">
                        <li class="day__item lesson container">
                            <ul class="lesson__list row" v-for="item in items" :key="item.time">
                                <li class="lesson__item lesson__item-time col-12 col-xs-4 col-md-4 col-lg-1" v-html="item.time"></li>
                                <li class="lesson__item lesson__item-description col-12 col-xs-12 col-md-12 col-lg-6" v-html="item.description" style="display: inline-grid;"></li>
                                <li class="lesson__item lesson__item-type col-7 col-xs-7 col-md-7 col-lg-2" v-html="item.lessonType" style="display: inline-grid"></li>
                                <!--<li class="lesson__item col-2">-</li>-->
                                <li class="lesson__item lesson__item-room col-4 col-xs-4 col-md-4 col-lg-2" v-html="item.room" style="display: inline-grid"></li>
                                <li class="lesson__item lesson__item-map col-1 col-xs-1 col-md-1 col-lg-1">
                                    <a :href="item.address" target="_blank" class="lesson__item-link" v-if="item.address.length > 0">
                                        <svg v-if="item.address != 'https://portal.sutd.ru'" width="39" height="49" viewBox="0 0 39 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M37.6326 19.5C37.6326 29.997 19.1326 47 19.1326 47C19.1326 47 2.13275 29.5 1.09644 20C0.0601171 10.5 7.49308 0.999986 18.1326 1C28.6327 1.00001 37.6326 9.00296 37.6326 19.5Z" stroke="#A3BFEF" stroke-width="2"/>
                                            <circle cx="19.1328" cy="20" r="7.5" fill="#CAE5FF" stroke="#A3BFEF" stroke-width="2"/>
                                        </svg>
                                        <svg v-if="item.address == 'https://portal.sutd.ru'" width="50" height="50" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g stroke="#A3BFEF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M15 11H12C10.8954 11 10 11.8954 10 13V23C10 24.1046 10.8954 25 12 25H22C23.1046 25 24 24.1046 24 23V20" />
                                                <path d="M19 11H25V17" />
                                                <path d="M18 18L25 11" />
                                            </g>
                                        </svg>
                                    </a>
                                    <span v-else>—</span>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>        
            </ul>
        </div>
    </section>
</template>
<script>
import {mapState, mapGetters} from "vuex";

export default{
    data:()=>({
            paginationNext: 1,
            paginationWeek: 0,
            dayName: ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота','воскресенье'],
            documentDownload: '', 
        }),
    computed:{
        ...mapState(['semestrimtoch', 'semestriptooch', 'semestrimtvech', 'semestriptovech', 'sessionimtoch', 'sessioniptooch', 'sessionimtvech', 'sessioniptovech','sessioniptoochspring','sessionimtochspring','sessioniptovechspring','sessionimtvechspring']),
        ...mapGetters(['semestrIptoOchGroups', 'semestrImtOchGroups', 'semestrIptoVechGroups', 'semestrImtVechGroups', 'sessionImtOchGroup', 'sessionImtVechGroup', 'sessionIptoOchGroup', 'sessionIptoVechGroup', 'sessionImtOchSpringGroup', 'sessionImtVechSpringGroup', 'sessionIptoOchSpringGroup', 'sessionIptoVechSpringGroup', 'getCalendar', 'getDefaultSchoolCalendar', 'getCurrentNumberWeek','halfYearImtIptoSemestr', 'halfYearImtIptoSession', 'halfYearImtIptoSpringSession', 'getNumberWeekStartSessionGroup', 'getNumberWeekEndSessionGroup', 'getNumberWeekStartAllSessionTeacher', 'getNumberWeekEndAllSessionTeacher', 'getSessionDataGroup', 'semestrOrAndSessionDataTeacher', 'getSemestrData', 'sessionDataGroup', 'sessionSpringDataGroup', 'semestrDataGroup']),

        // Возвращает дату начала и дату конца текущей недели
        weekDates(){
            let curr = new Date() 
            let curr2 = new Date()
            let currDay = new Date()
            let dow = curr.getDay()
            if (dow === 0){
                dow = 7
            }
            let first = curr.getDate() - dow + this.paginationNext
            let last = curr2.getDate() - dow  + 6 + this.paginationNext
            let firstday = new Date(currDay.setDate(first-1))
            
            let daysNames = []
            for (let i = 0; i < 7; i++){
                let day = new Date(firstday.setDate(firstday.getDate()+1))
                daysNames.push(String(day.toLocaleDateString()))
            }
            firstday = new Date(curr.setDate(first))
            let lastday = new Date(curr2.setDate(last))
            //console.log(firstday, lastday, daysNames)
            return {firstday, lastday, daysNames}
        },
        //Возвращает номер недели
        weekNumber(){console.log(this.getCurrentNumberWeek)
            return this.getCurrentNumberWeek.currentweek + this.paginationWeek;
        },
        //
        firstWeek(){
            let calculateFirstWeek = this.instituteData[0]?.firstWeek ?? this.getDefaultSchoolCalendar.firstsemestr[0];
            //console.log(this.weekNumber)
            return (this.weekNumber > calculateFirstWeek) ? false : true
        },
        //
        lastWeek(){
            let calculateLastWeek = this.instituteData[0]?.lastWeek ?? this.getDefaultSchoolCalendar.summersession[1];
            return (this.weekNumber < calculateLastWeek) ? false : true
        },
        //Проверяет на числитель/знаменатель текущую неделю
        isUpWeek(){
            return (this.weekNumber % 2) ? false : true;// === (window.WEEK_UP_NUMBER % 2)
        },
        isSeason(){
            return (this.instituteData[0]?.season.length>0) ? "  |  " +this.instituteData[0]?.season : '';
        },
        //
        /*sessionDataGroup(){
            let group = this.$route.params.group
            if(this.sessionImtOchGroup.includes(group)){
                return this.sessionimtoch;
            } else if(this.sessionImtVechGroup.includes(group)){
                return this.sessionimtvech;
            } else if(this.sessionIptoOchGroup.includes(group)){
                return this.sessioniptooch;
            } else if(this.sessionIptoVechGroup.includes(group)){
                return this.sessioniptovech;
            } return[];
        },
        //
        sessionSpringDataGroup(){
            let group = this.$route.params.group
            if(this.sessionImtOchSpringGroup.includes(group)){
                return this.sessionimtochspring;
            } else if(this.sessionImtVechSpringGroup.includes(group)){
                return this.sessionimtvechspring;
            } else if(this.sessionIptoOchSpringGroup.includes(group)){
                return this.sessioniptoochspring;
            } else if(this.sessionIptoVechSpringGroup.includes(group)){
                return this.sessioniptovechspring;
            } return[];
        },
        
        semestrDataGroup(){ //
            let group = this.$route.params.group
            if(this.semestrIptoOchGroups.includes(group)){     
                return this.semestriptooch;
            } else if(this.semestrImtOchGroups.includes(group)){
                return this.semestrimtoch;
            } else if(this.semestrIptoVechGroups.includes(group)){
                return this.semestriptovech;
            } else if(this.semestrImtVechGroups.includes(group)){
                return this.semestrimtvech;
            } return[];
        },*/

        //Подгружает данные из файла расписания института выбранной группы
        instituteData(){
            let group = this.$route.params.group // Вывод шифра группы
            let teacher = this.$route.params.teacher // Вывод шифра группы
            //console.log(teacher)
            //const find = (group) ? group : teacher; console.log(find)
            const weekNumberCalendar = this.weekNumber; // Текущая неделя
            //console.log(weekNumberCalendar)
            let startShowWeek = this.getDefaultSchoolCalendar.firstsemestr[0]; // Начать показывать с этой недели
            let endShowWeek = this.getDefaultSchoolCalendar.summersession[1]; // Заканчивать показывать на этой неделе
            let season = '';
            if(group  || teacher){
                if(this.getCalendar[0].weeks?.length){
                    if(this.halfYearImtIptoSemestr === 'I' && !this.halfYearImtIptoSession){ // Первый семестр
                        //console.log('Группа. Первый семестр')
                        startShowWeek = this.getDefaultSchoolCalendar.firstsemestr[0]; // Начать показывать с этой недели
                        endShowWeek = this.getDefaultSchoolCalendar.firstsemestr[1]; // Заканчивать показывать на этой неделе
                        if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){ // Если текущая неделя входит в диапазон семестра, то отправить данные семестра группы
                            if(group){
                                season = 'Cеместр';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, semestrDataGroup: this.semestrDataGroup(group), season: season}]
                            } else if(teacher){
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, dataTeacher: this.semestrOrAndSessionDataTeacher(teacher, 0), season: season}]
                            }
                        }
                    } else if(this.halfYearImtIptoSemestr === 'I' && this.halfYearImtIptoSession === 'I'){ // Первый семестр и зимняя сессия
                        //console.log('Группа. Первый семестр | Зимняя сессия')
                        let startSession = this.getNumberWeekStartSessionGroup(group, this.sessionDataGroup(group), this.getCalendar[0].weeks) - 1; // Семестр заканчивается до начала сессии
                        if(group){
                            startShowWeek = this.getDefaultSchoolCalendar.firstsemestr[0]; // Начать показывать с этой недели
                            startSession = this.getNumberWeekStartSessionGroup(group, this.sessionDataGroup(group), this.getCalendar[0].weeks) - 1; // Семестр заканчивается до начала сессии
                            endShowWeek = this.getNumberWeekEndSessionGroup(group, this.sessionDataGroup(group), this.getCalendar[0].weeks) ?? this.getDefaultSchoolCalendar.wintersession[1]; // Заканчивать показывать на этой неделе
                            if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= startSession+1){ // Если текущая неделя входит в диапазон семестра, то отправить данные семестра группы
                                season = 'Cеместр';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, semestrDataGroup: this.semestrDataGroup(group), season: season}]
                            } else if(startSession <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){ // Если текущая неделя входит в диапазон сессии, то отправить данные сессии группы
                                season = 'Cеcсия';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, sessionDataGroup: this.getSessionDataGroup(this.sessionDataGroup(group), group), season: season}]
                            }
                        } else if(teacher){
                            startShowWeek = this.getDefaultSchoolCalendar.firstsemestr[0]; // Начать показывать с этой недели
                            endShowWeek = this.getNumberWeekEndAllSessionTeacher(teacher, this.getCalendar[0].weeks); // Заканчивать показывать на этой неделе
                            if(endShowWeek === 0 || !endShowWeek) endShowWeek = this.getDefaultSchoolCalendar.wintersession[1];
                            if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, dataTeacher: this.semestrOrAndSessionDataTeacher(teacher, 1), season: season}]
                            }
                        }
                    } else if(this.halfYearImtIptoSemestr === 'II' && this.halfYearImtIptoSession === 'I'){ // Зимняя сессия и второй семестр
                        //console.log('Группа. Зимняя сессия | Второй семестр')
                        let endSession = this.getDefaultSchoolCalendar.wintersession[1];
                        if(group){
                            startShowWeek = this.getNumberWeekStartSessionGroup(group, this.sessionDataGroup(group), this.getCalendar[0].weeks)  ?? this.getDefaultSchoolCalendar.wintersession[0]; // Начать показывать с этой недели
                            endSession = this.getNumberWeekEndSessionGroup(group, this.sessionDataGroup(group), this.getCalendar[0].weeks) - 1;
                            endShowWeek = this.getDefaultSchoolCalendar.secondsemestr[1]; // Заканчивать показывать на этой неделе
                            if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endSession+1){ // Если текущая неделя входит в диапазон сессии, то отправить данные сессии группы
                                season = 'Cессия';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, sessionDataGroup: this.getSessionDataGroup(this.sessionDataGroup(group), group), season: season}]
                            } else if(endSession <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){ // Если текущая неделя входит в диапазон семестра, то отправить данные семестра группы
                                //console.log('ES'+endSession, 'WN'+weekNumberCalendar, 'ESW'+endShowWeek)
                                season = 'Cеместр';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, semestrDataGroup: this.semestrDataGroup(group), season: season}]
                            }
                        } else if(teacher){
                            startShowWeek = this.getNumberWeekStartAllSessionTeacher(teacher, this.getCalendar[0].weeks); // Начать показывать с этой недели
                            if(startShowWeek === 0 || !startShowWeek) startShowWeek = this.getDefaultSchoolCalendar.wintersession[0];
                            endShowWeek = this.getDefaultSchoolCalendar.secondsemestr[1]; // Заканчивать показывать на этой неделе
                            if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, dataTeacher: this.semestrOrAndSessionDataTeacher(teacher, 2), season: season}]
                            }
                        }
                    } else if(this.halfYearImtIptoSemestr === 'II' && (!this.halfYearImtIptoSession && !this.halfYearImtIptoSpringSession)){ // Второй семестр /*this.sessionSpringDataGroup(group).length === 0*/
                        //console.log('Группа. Второй семестр')
                        startShowWeek = this.getDefaultSchoolCalendar.secondsemestr[0]; // Начать показывать с этой недели
                        endShowWeek = this.getDefaultSchoolCalendar.secondsemestr[1]; // Заканчивать показывать на этой неделе
                        if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){ // Если текущая неделя входит в диапазон семестра, то отправить данные семестра группы
                            if(group){
                                season = 'Cеместр';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, semestrDataGroup: this.semestrDataGroup(group), season: season}]
                            } else if(teacher){
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, dataTeacher: this.semestrOrAndSessionDataTeacher(teacher, 3), season: season}]
                            }
                        }
                    } else if(this.halfYearImtIptoSemestr === 'II' && (this.halfYearImtIptoSession === 'II' || this.halfYearImtIptoSpringSession === 'II')){ // Второй семестр и летняя сессия /*this.sessionSpringDataGroup(group).length > 0*/
                        //console.log('Группа. Второй семестр | Весення или Летняя сессия')
                        if(group){
                            let session = (this.sessionSpringDataGroup(group).length > 0) ? this.sessionSpringDataGroup(group) : this.sessionDataGroup(group);
                            startShowWeek = this.getDefaultSchoolCalendar.secondsemestr[0]; // Начать показывать с этой недели
                            const startSession = this.getNumberWeekStartSessionGroup(group, session, this.getCalendar[0].weeks) - 1; // Семестр заканчивается до начала сессии
                            endShowWeek = this.getNumberWeekEndSessionGroup(group, session, this.getCalendar[0].weeks); // Заканчивать показывать на этой неделе
                            if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= startSession){ // Если текущая неделя входит в диапазон семестра, то отправить данные семестра группы
                                season = 'Cеместр';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, semestrDataGroup: this.semestrDataGroup(group), season: season}]
                            } else if(startSession <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){ // Если текущая неделя входит в диапазон сессии, то отправить данные сессии группы
                                season = 'Cессия';
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, sessionDataGroup: this.getSessionDataGroup(session, group), season: season}]
                            }
                        } else if(teacher){
                            startShowWeek = this.getDefaultSchoolCalendar.secondsemestr[0];
                            endShowWeek = this.getNumberWeekEndAllSessionTeacher(teacher, this.getCalendar[0].weeks) // Заканчивать показывать на этой неделе
                            if(endShowWeek === 0 || !endShowWeek) endShowWeek = this.getDefaultSchoolCalendar.summersession[1];
                            if(startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endShowWeek){
                                return [{firstWeek: startShowWeek, lastWeek: endShowWeek, dataTeacher: this.semestrOrAndSessionDataTeacher(teacher, 4), season: season}]
                            }
                        }
                    }
                }
            }
            return[] // иначе ничего
        },

        groupIndex(){ //Возвращает номер столбца выбранной группы 
            let group = this.$route.params.group
            return this.semestrDataGroup(group)[4]?.indexOf(group)
        },

        timetable(){ //Возвращает объект с информацией занятий по группе
            let day, time, description, room, lessonType, address
            let res = {}
            if(this.instituteData[0]?.semestrDataGroup){
                //console.log('Данные семестра', this.instituteData[0]?.semestrDataGroup);
                for(let i = 5; i < this.instituteData[0]?.semestrDataGroup.length; i++){ // Начать с 6 строчки
                    let row = this.instituteData[0]?.semestrDataGroup[i]
                    if (row[0]){
                        day = row[0]
                    }
                    if (row[1]){
                        time = row[1]
                        time = time.replace('-', '<br class="item-time__br"/>&ensp;—&ensp;<br class="item-time__br"/>')
                    }
                    if (row[this.groupIndex] ?? false){
                        let isUpWeek = i%2 > 0
                        if(isUpWeek !== this.isUpWeek){
                            description = row[this.groupIndex]
                            room = row[this.groupIndex+1]
                            // Проверка наличия другого указанного времени
                            if(Number(description[0])&&Number(description[1])){
                                time= row[this.groupIndex].slice(0,11)
                                time = time.replace('-', '<br class="item-time__br"/>&ensp;—&ensp;<br class="item-time__br"/>')
                                description = row[this.groupIndex].slice(12) 
                            }
                            let regexlessonType = /(\(.{1,10}\d+.+\))|(\(прак.\))|(\(лекц\..*\))|(\(лек\..*\))|(\(л.р\..*\))/gi
                            //Вывод информации о виде занятий из общей строки
                            if(description.indexOf(';') !== -1){ //в случае сдвоенных предметов
                                let pie = description.split(';')
                                let newDescription= ''
                                lessonType = ''
                                pie.forEach((e,i,a) => {
                                    if(regexlessonType.test(e)){
                                        lessonType = lessonType + String(e.match(regexlessonType)).slice(1, String(e.match(regexlessonType)).length - 1)// + '<br/>'
                                        if(i !== a.length-1){
                                            lessonType = lessonType + '<hr class="hr-dotted">'
                                        }
                                    } else{
                                        lessonType = '-'
                                    }
                                    newDescription = String(newDescription.split('.,')) + String(e.replace(regexlessonType, '<br/>'))
                                    if(i !== a.length-1){
                                        newDescription = newDescription + '.<hr class="hr-dotted">'
                                    }
                                })   
                                description = newDescription
                            } 
                            else{
                                lessonType = String(description.match(regexlessonType)).slice(1, String(description.match(regexlessonType)).length - 1)
                                description = String(description.replace(regexlessonType, ''))
                            }
                            lessonType = '<span class="item-type__description">Вид занятий:&emsp;</span>'+lessonType
                            //Проверка адреса Моховой
                            // let addressMokhovaya = ', ул. Моховая, д. 26'
                            let addressMokhovaya = /(, *ул. *Моховая, д. *26 *)/gi
                            if(addressMokhovaya.test(description)){
                                // description = description.slice(0 , description.length - (addressMokhovaya.length))
                                // room = addressMokhovaya.slice(1)
                                room = 'ул. Моховая, д. 26'
                                description = String(description.replace(addressMokhovaya, ''))
                            }
                            //Вывод информации об аудитории из общей строки
                            let regexRoom = /(, *[А-Я]\d{3})|([А-Я]\d{3}|(, ДО))/g
                            //let regexRoomPoint = /(, *[А-Я]\d{3}\.\d{1})/g    //Для таких аудиторий как Д323.1 и Д323.2
                            let regexRoomNew = /(, *([А-Я]\d{3}\.\d{1})|(, *[А-Я]\d{3}))|([А-Я]\d{3}|(, ДО))/g
                            if(regexRoom.test(description)){
                                let lineLength = 4
                                let arrayRoom = [];
                                room = ''
                                //Здесь для любых
                                if(regexRoomNew.test(description)){
                                    arrayRoom = description.match(regexRoomNew)
                                    description = description.replace((regexRoomNew), '')
                                }
                                arrayRoom.forEach((croom, cindex, carray) => {
                                    if(/(, ДО)/g.test(croom)){
                                        lineLength = 2
                                    }
                                    else if(/[А-Я]\d{3}\.\d{1}/.test(croom)){
                                        lineLength = 6
                                    } else{
                                        lineLength = 4
                                    }
                                    room = room + croom.slice(croom.length - lineLength, croom.length)
                                    if(cindex !== carray.length-1){
                                        room = room + '<hr class="hr-dotted">'
                                    }
                                })
                            }
                            
                            if(/(.*[Дд]\d.*)/.test(room)){
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.335917%2C59.925163&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/(.*[Вв]\d.*)/.test(room)){
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.309389%2C59.921271&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/(.*[Мм]\d.*)/.test(room)){/*room === 'М, д.26''ул. Моховая, д. 26'*/
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.347802%2C59.942172&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/(.*[Бб]\d.*)/.test(room)){
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.316369%2C59.934985&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/^ДО$/.test(room)){ 
                                address = ['https://portal.sutd.ru']
                            } else {
                                address =[]
                            }
                            res[day]??=[]
                            res[day].push({time, description, room, lessonType, address})
                        }
                    }
                }
            } else if(this.instituteData[0]?.sessionDataGroup){
                //console.log('Данные сессии', this.instituteData[0]?.sessionDataGroup)
                if(this.getCalendar[0].weeks.length > 0){
                    let indexes = this.instituteData[0].sessionDataGroup.map(
                        (v, i) => {
                            let a = false;
                            if(v[9].length > 6){
                                let b = v[9].split('.')
                                let c = new Date(b[2],b[1]-1,b[0]).toLocaleDateString("en-US")
                                a = this.getCalendar[0].weeks[this.weekNumber-1].includes(c)
                                //console.log(this.getCalendar[0].weeks[this.weekNumber-1], b, c, i)
                            } else {
                                a = this.getCalendar[0].weeks[this.weekNumber-1].includes(
                                    new Date((v[9] - 25569) * 86400 * 1000).toLocaleDateString("en-US")
                                )
                                //console.log(v[9])
                            }
                            
                            return (a) ? i : -1
                        }).filter(i => i !== -1)
                    if(indexes.length > 0){
                        //console.log(indexes)
                        for(let ind = 0; ind < indexes.length; ind++){
                            let i = indexes[ind]
                            //let dayDate = new Date((this.instituteData[0].sessionData[i][9] - 25569) * 86400 * 1000).toLocaleDateString("en-US")
                            let dayGetDay = new Date();
                            if(this.instituteData[0].sessionDataGroup[i][9].length > 6){
                                let b = this.instituteData[0].sessionDataGroup[i][9].split('.');
                                dayGetDay = new Date(new Date(b[2],b[1]-1,b[0]).toLocaleDateString("en-US")).getDay();
                            } else {
                                dayGetDay = new Date((this.instituteData[0].sessionDataGroup[i][9] - 25569) * 86400 * 1000).getDay();
                            }
                            if (dayGetDay === 0){ dayGetDay = 7 }
                            const excelEpoch = new Date(Date.UTC(1899, 11, 30));
                            const excelMs = (this.instituteData[0].sessionDataGroup[i][10] - 1) * 24 * 60 * 60 * 1000;
                            const jsDateInMs = excelEpoch.getTime() + excelMs;
                            const jsDate = new Date(jsDateInMs);
                            const hours = jsDate.getUTCHours();
                            const minutes = jsDate.getUTCMinutes();
                            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                            day = this.dayName[dayGetDay-1];
                            time = formattedTime+`<span class="item-type__description aaaaaa${i}"></span>`;
                            description = this.instituteData[0].sessionDataGroup[i][4] + ' ';
                            description = description + this.instituteData[0].sessionDataGroup[i][7];
                            room = this.instituteData[0].sessionDataGroup[i][11]
                            lessonType = this.instituteData[0].sessionDataGroup[i][8];
                            lessonType = '<span class="item-type__description">Вид занятий:&emsp;</span>'+lessonType
                            let addressMokhovaya = /(, *ул. *Моховая, д. *26 *)/gi
                            if(addressMokhovaya.test(description)){
                                // description = description.slice(0 , description.length - (addressMokhovaya.length))
                                // room = addressMokhovaya.slice(1)
                                room = 'ул. Моховая, д. 26'
                                description = String(description.replace(addressMokhovaya, ''))
                            }
                            //Вывод информации об аудитории из общей строки
                            let regexRoom = /(, *[А-Я]\d{3})|([А-Я]\d{3}|(, ДО))/g
                            //let regexRoomPoint = /(, *[А-Я]\d{3}\.\d{1})/g    //Для таких аудиторий как Д323.1 и Д323.2
                            let regexRoomNew = /(, *([А-Я]\d{3}\.\d{1})|(, *[А-Я]\d{3}))|([А-Я]\d{3}|(, ДО))/g
                            if(regexRoom.test(description)){
                                let lineLength = 4
                                let arrayRoom = [];
                                room = ''
                                if(regexRoomNew.test(description)){
                                    arrayRoom = description.match(regexRoomNew)
                                    description = description.replace((regexRoomNew), '')
                                }
                                let roomSec = true;
                                arrayRoom.forEach(e => {
                                    if(/(, ДО)/g.test(e)){
                                        lineLength = 2
                                    }
                                    else if(/[А-Я]\d{3}\.\d{1}/.test(e)){
                                        lineLength = 6
                                    } else{
                                        lineLength = 4
                                    }
                                    if(roomSec){roomSec = false;room = room + e.slice(e.length - lineLength, e.length) + '<hr class="hr-dotted">'}
                                    else {room = room + e.slice(e.length - lineLength, e.length)}
                                })
                            }


                            if(/(.*[Дд]\d.*)/.test(room)){
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.335917%2C59.925163&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/(.*[Вв]\d.*)/.test(room)){
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.309389%2C59.921271&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/(.*[Мм]\d.*)/.test(room)){/*room === 'М, д.26''ул. Моховая, д. 26'*/
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.347802%2C59.942172&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/(.*[Бб]\d.*)/.test(room)){
                                address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.316369%2C59.934985&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                            } else if(/^ДО$/.test(room)){ 
                                address = ['https://portal.sutd.ru']
                            } else {
                                address =[]
                            }
                            //console.log(day, {time, description, room, lessonType, address});
                            res[day]??=[]
                            res[day].push({time, description, room, lessonType, address})
                            //console.log(res)
                            
                        }
                        const dayWeights = { 'понедельник': 1, 'вторник': 2, 'среда': 3, 'четверг': 4, 'пятница': 5, 'суббота': 6, 'воскресенье': 7 };
                        let sortRes = Object.keys(res)
                            .sort((a,b)=> dayWeights[a] - dayWeights[b])
                            .reduce((acc, key) => {
                                acc[key] = res[key];return acc;
                            }, {});
                        //console.log(sortRes)
                        res = sortRes;
                    }
                }
            } else if(this.instituteData[0]?.dataTeacher){
                if(this.getCalendar[0].weeks.length > 0){
                    if(this.instituteData[0]?.dataTeacher.length > 0){
                        for(let i = 0; i < this.instituteData[0]?.dataTeacher.length;i++){
                            //console.log(this.instituteData[0]?.dataTeacher[i]._)
                            if(this.instituteData[0]?.dataTeacher[i]._ === 0){// Если семестр
                                const group = this.instituteData[0]?.dataTeacher[i].group;
                                const weekNumberCalendar = this.weekNumber;
                                let show = false;
                                if(this.instituteData[0]?.dataTeacher[i].epoch === 1 || this.instituteData[0]?.dataTeacher[i].epoch === 4){//console.log(1,4)
                                    //console.log('Группа. Первый семестр | Зимняя сессия')
                                    //console.log('Группа. Второй семестр | Весення или Летняя сессия')
                                    const startShowWeek = (this.instituteData[0]?.dataTeacher[i].epoch === 1) ? this.getDefaultSchoolCalendar.firstsemestr[0] : this.getDefaultSchoolCalendar.secondsemestr[0];
                                    let session = (this.sessionSpringDataGroup(group).length > 0) ? this.sessionSpringDataGroup(group) : this.sessionDataGroup(group);
                                    let startSession = this.getDefaultSchoolCalendar.secondsemestr[1];
                                    if(session.length > 0){
                                        startSession = this.getNumberWeekStartSessionGroup(group, session, this.getCalendar[0].weeks) - 1;
                                    }
                                    show = (startShowWeek <= weekNumberCalendar && weekNumberCalendar <= startSession) ? true : false;
                                    //console.log('SSW: '+startShowWeek, 'WN '+weekNumberCalendar, 'SS '+startSession, show)
                                } else if(this.instituteData[0]?.dataTeacher[i].epoch === 2){//console.log(2)
                                    //console.log('Группа. Зимняя сессия | Второй семестр')
                                    const endSession = this.getNumberWeekEndSessionGroup(group, this.sessionDataGroup(group), this.getCalendar[0].weeks)+1;
                                    const endShowWeek = this.getDefaultSchoolCalendar.secondsemestr[1];
                                    show = (endSession <= weekNumberCalendar && weekNumberCalendar <= endShowWeek) ? true : false;
                                    //console.log(group, 'ES: '+endSession, 'WN '+weekNumberCalendar, 'ESW '+endShowWeek, show)
                                } else if(this.instituteData[0]?.dataTeacher[i].epoch === 0 || this.instituteData[0]?.dataTeacher[i].epoch === 3){//console.log(0,3)
                                    //console.log('Группа. Первый семестр')
                                    //console.log('Группа. Второй семестр')
                                    const startShowWeek = (this.instituteData[0]?.dataTeacher[i].epoch === 0) ? this.getDefaultSchoolCalendar.firstsemestr[0] : this.getDefaultSchoolCalendar.secondsemestr[0];
                                    const endShowWeek = (this.instituteData[0]?.dataTeacher[i].epoch === 0) ? this.getDefaultSchoolCalendar.firstsemestr[1] : this.getDefaultSchoolCalendar.secondsemestr[1];
                                    show = (startShowWeek <= weekNumberCalendar && weekNumberCalendar <= endShowWeek) ? true : false;
                                }

                                if((this.instituteData[0]?.dataTeacher[i].isweekup === this.isUpWeek) && show){
                                    day = this.instituteData[0]?.dataTeacher[i].day;
                                    time = this.instituteData[0]?.dataTeacher[i].time;
                                    time = time.replace('-', `<br class="item-time__br"/>&ensp;—&ensp;<br class="item-time__br"/><span class="item-type__description aaaaaa${i}"></span>`)
                                    const ngroup = this.instituteData[0]?.dataTeacher[i].group;
                                    description = this.instituteData[0]?.dataTeacher[i].dics;//console.log(description)
                                    room = this.instituteData[0]?.dataTeacher[i].room;
                                    let regexlessonType = /(\(.{1,10}\d+.+\))|(\(прак.\))|(\(лекц\..*\))|(\(лек\..*\))|(\(л.р\..*\))/gi
                                    //Вывод информации о виде занятий из общей строки
                                    if(description.indexOf(';') !== -1){ //в случае сдвоенных предметов
                                        let pie = description.split(';')
                                        let newDescription= ''
                                        lessonType = ''
                                        pie.forEach((e,i,a) => {
                                            if(regexlessonType.test(e)){
                                                lessonType = lessonType + String(e.match(regexlessonType)).slice(1, String(e.match(regexlessonType)).length - 1)// + '<br/>'
                                                if(i !== a.length-1){
                                                    lessonType = lessonType + '<hr class="hr-dotted">'
                                                } 
                                            } else{
                                                lessonType = '-'
                                            }
                                            //console.log(newDescription)
                                            //if(newDescription.indexOf('.,') !== -1){console.log(newDescription)
                                            newDescription = String(newDescription.split('.,')/*.join('.<hr class="hr-dotted">,')*/) + String(e.replace(regexlessonType, '<br/>'))
                                            //console.log(newDescription)
                                            if(i !== a.length-1){
                                                newDescription = newDescription + '.<hr class="hr-dotted">'
                                            }
                                            //} else {
                                                //newDescription = newDescription + String(e.replace(regexlessonType, '<br/>'))
                                            //}
                                        })
                                        //console.log(lessonType)
                                        description = `<strong>`+ngroup+`</strong>`+newDescription
                                        lessonType = '<span class="item-type__description" style="display:block;visibility:hidden;height:46px">Вид занятий:&emsp;</span>'+lessonType
                                    } 
                                    else{
                                        lessonType = String(description.match(regexlessonType)).slice(1, String(description.match(regexlessonType)).length - 1)
                                        description = `<strong>`+ngroup+`</strong>`+String(description.replace(regexlessonType, ''))
                                        //console.log(lessonType)
                                        lessonType = '<span class="item-type__description" style="display:block;visibility:hidden;height:18px">Вид занятий:&emsp;</span>'+lessonType
                                    }
                                    
                                    
                                    //Проверка адреса Моховой
                                    let addressMokhovaya = /(, *ул. *Моховая, д. *26 *)/gi
                                    if(addressMokhovaya.test(description)){
                                        // description = description.slice(0 , description.length - (addressMokhovaya.length))
                                        // room = addressMokhovaya.slice(1)
                                        room = 'ул. Моховая, д. 26'
                                        description = String(description.replace(addressMokhovaya, ''))
                                    }
                                    //Вывод информации об аудитории из общей строки
                                    let regexRoom = /(, *[А-Я]\d{3})|([А-Я]\d{3}|(, ДО))/g
                                    //let regexRoomPoint = /(, *[А-Я]\d{3}\.\d{1})/g    //Для таких аудиторий как Д323.1 и Д323.2
                                    let regexRoomNew = /(, *([А-Я]\d{3}\.\d{1})|(, *[А-Я]\d{3}))|([А-Я]\d{3}|(, ДО))/g
                                    if(regexRoom.test(description)){
                                        let lineLength = 4
                                        let arrayRoom = [];
                                        room = ''
                                        //Здесь для любых
                                        if(regexRoomNew.test(description)){
                                            arrayRoom = description.match(regexRoomNew)
                                            description = description.replace((regexRoomNew), '')
                                        }
                                        arrayRoom.forEach((croom, cindex, carray) => {
                                            if(/(, ДО)/g.test(croom)){
                                                lineLength = 2
                                            }
                                            else if(/[А-Я]\d{3}\.\d{1}/.test(croom)){
                                                lineLength = 6
                                            } else{
                                                lineLength = 4
                                            }
                                            room = room + croom.slice(croom.length - lineLength, croom.length)
                                            if(cindex !== carray.length-1){
                                                room = room + '<hr class="hr-dotted">'
                                            }
                                        })
                                        if(arrayRoom.length > 1) {
                                            room = `<span class="item-type__description" style="display:block;visibility:hidden;height:46px">Аудитория:</span>`+ room
                                        }
                                    } else {
                                        room = `<span class="item-type__description" style="display:block;visibility:hidden;height:18px">Аудитория:</span>`+ room
                                    } console.log(room)
                                    if(/(.*[Дд]\d.*)/.test(room)){
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.335917%2C59.925163&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/(.*[Вв]\d.*)/.test(room)){
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.309389%2C59.921271&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/(.*[Мм]\d.*)/.test(room)){/*room === 'М, д.26''ул. Моховая, д. 26'*/
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.347802%2C59.942172&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/(.*[Бб]\d.*)/.test(room)){
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.316369%2C59.934985&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/ДО$/.test(room)){ 
                                        address = ['https://portal.sutd.ru']
                                    } else {
                                        address =[]
                                    }
                                    res[day]??=[]
                                    res[day].push({time, description, room, lessonType, address})
                                }
                            } else if(this.instituteData[0]?.dataTeacher[i]._ === 1 || this.instituteData[0]?.dataTeacher[i]._ === 2){ // Сессии
                                //console.log('_')
                                if(this.getCalendar[0].weeks[this.weekNumber-1].includes(this.instituteData[0]?.dataTeacher[i].date)){
                                    day = this.instituteData[0]?.dataTeacher[i].day
                                    time = this.instituteData[0]?.dataTeacher[i].time+`<span class="item-type__description aaaaaa${i}"></span>`;
                                    description = this.instituteData[0]?.dataTeacher[i].disc + ' ';
                                    description = `<strong>`+this.instituteData[0]?.dataTeacher[i].group+`</strong>`+description;
                                    room = this.instituteData[0]?.dataTeacher[i].room
                                    lessonType = this.instituteData[0]?.dataTeacher[i].lessontype
                                    lessonType = '<span class="item-type__description">Вид занятий:&emsp;</span>'+lessonType
                                    let addressMokhovaya = /(, *ул. *Моховая, д. *26 *)/gi
                                    if(addressMokhovaya.test(description)){
                                        // description = description.slice(0 , description.length - (addressMokhovaya.length))
                                        // room = addressMokhovaya.slice(1)
                                        room = 'ул. Моховая, д. 26'
                                        description = String(description.replace(addressMokhovaya, ''))
                                    }
                                    //Вывод информации об аудитории из общей строки
                                    let regexRoom = /(, *[А-Я]\d{3})|([А-Я]\d{3}|(, ДО))/g
                                    //let regexRoomPoint = /(, *[А-Я]\d{3}\.\d{1})/g    //Для таких аудиторий как Д323.1 и Д323.2
                                    let regexRoomNew = /(, *([А-Я]\d{3}\.\d{1})|(, *[А-Я]\d{3}))|([А-Я]\d{3}|(, ДО))/g
                                    if(regexRoom.test(description)){
                                        let lineLength = 4
                                        let arrayRoom = [];
                                        room = ''
                                        if(regexRoomNew.test(description)){
                                            arrayRoom = description.match(regexRoomNew)
                                            description = description.replace((regexRoomNew), '')
                                        }
                                        let roomSec = true;
                                        arrayRoom.forEach(e => {
                                            if(/(, ДО)/g.test(e)){
                                                lineLength = 2
                                            }
                                            else if(/[А-Я]\d{3}\.\d{1}/.test(e)){
                                                lineLength = 6
                                            } else{
                                                lineLength = 4
                                            }
                                            if(roomSec){roomSec = false;room = room + e.slice(e.length - lineLength, e.length) + '<hr class="hr-dotted">'}
                                            else {room = room + e.slice(e.length - lineLength, e.length)}
                                        })
                                    } 
                                    if(/(.*[Дд]\d.*)/.test(room)){
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.335917%2C59.925163&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/(.*[Вв]\d.*)/.test(room)){
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.309389%2C59.921271&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/(.*[Мм]\d.*)/.test(room)){/*room === 'М, д.26''ул. Моховая, д. 26'*/
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.347802%2C59.942172&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/(.*[Бб]\d.*)/.test(room)){
                                        address = ['https://yandex.ru/maps/2/saint-petersburg/?ll=30.316369%2C59.934985&mode=usermaps&source=constructorLink&um=constructor%3A80c1d043b17b1b6ef1fd6ca0dc1986807c705387ee4a072a81364cdbb8d6f6ed&z=17']
                                    } else if(/ДО$/.test(room)){ 
                                        address = ['https://portal.sutd.ru']
                                    } else {
                                        address =[]
                                    }
                                    //console.log(day, {time, description, room, lessonType, address});
                                    res[day]??=[]
                                    res[day].push({time, description, room, lessonType, address})
                                }
                            }
                        }
                        const dayWeights = { 'понедельник': 1, 'вторник': 2, 'среда': 3, 'четверг': 4, 'пятница': 5, 'суббота': 6, 'воскресенье': 7 };
                        let sortRes = Object.keys(res)
                            .sort((a,b)=> dayWeights[a] - dayWeights[b])
                            .reduce((acc, key) => {
                                let uniq = res[key].filter((v, i, a) => a.findIndex(t => {return JSON.stringify(t) === JSON.stringify(v)}) === i);
                                acc[key] = uniq.sort((a, b) => {
                                    const normalize = (timeStr) => {
                                        const time = timeStr.split('<')[0]; // Берем только начало строки до тегов
                                            return time.length === 4 ? '0' + time : time; // Если '8:30', делаем '08:30'
                                        };
                                    return normalize(a.time).localeCompare(normalize(b.time));
                                });
                                return acc;
                            }, {});
                        res = sortRes;
                    }
                }
            }
            //console.log(res)
            return res  
        }
    },

    
    methods:{
        paginationStep(direction){ // Устанавлиает значение шага недель
            this.paginationNext += (direction*7);
            this.paginationWeek += direction;
        }/*,
        documentDownloadChoice(check){
            if(check){
                this.documentDownload = '/raspisaniye_ptio.xls'
            } else{
                this.documentDownload = '/raspisaniye_mt.xlsx'
            }   
        },*/
    }/*,
    watch:{
        weekNumber(){
            
        },
    }*/

}
</script>
<style>
.firstWeek {
    visibility: hidden;
}
.lastWeek {
    visibility: hidden;
}
</style>